import { ImageResizerTutorialIcon } from "components/common/Icons/ImageResizerTutorialIcon";
import { Translate } from "components/common/Translate/Translate";
import { TutorialParent } from "../TutorialParent";

export const EnlargerTutorial = () => {
    return (
        <TutorialParent>
            <div className="flex flex-col gap-2">
                {/* header */}
                <h2 className="font-semibold whitespace-nowrap sub-heading mb-3">
                    <Translate keyName="tutorial-title" />
                </h2>
                {/* tutorial points */}
                <div className="">
                    <Translate keyName="tutorial-1" />
                </div>
                <div className="">
                    <Translate keyName="tutorial-2" />
                </div>
                <div className="">
                    <Translate keyName="tutorial-3" />
                </div>
            </div>
            <div className="bg-slate-50 dark:bg-darkSurface-200 px-12 py-28">
                <ImageResizerTutorialIcon />
            </div>
        </TutorialParent>
    );
};
